import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import CardSkeleton from '../../ClientCardsViewV2/components/CardSkeleton'

const useStyles = makeStyles(() => ({
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  skeleton: {
    height: '18.75rem',
    width: '16.5rem',
    margin: '1rem',
    display: 'flex',
    background: '#FAFAF9',
    borderRadius: 'var(--border-radius-lg)',
    padding: '1.75rem',
    alignItems: 'center',
    flexDirection: 'column',
    border: 'var(--border-neutral-normal)'
  }
}))

const BlocksListSkeleton = ({
  containerClassName,
  cardListLength,
  itemClassName,
  cardComponent: CardComponent
}) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.skeletonContainer, {
        [containerClassName]: Boolean(containerClassName)
      })}
    >
      {Array(cardListLength)
        .fill()
        .map((_, i) => (
          <div
            key={i}
            className={clsx(classes.skeleton, {
              [itemClassName]: Boolean(itemClassName)
            })}
          >
            <CardComponent loading />
          </div>
        ))}
    </div>
  )
}

BlocksListSkeleton.propTypes = {
  cardListLength: PropTypes.number,
  itemClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  cardComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
    .isRequired
}

BlocksListSkeleton.defaultProps = {
  cardListLength: 5,
  itemClassName: '',
  containerClassName: '',
  cardComponent: CardSkeleton
}

export default BlocksListSkeleton
